export default __webpack_public_path__ + "static/media/dovima_with_elephants.3c22bdbd.jpg";